import * as React from "react";
const SvgMac = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M91.6 73.8h-84c-2.6 0-4.7-2.1-4.7-4.7h93.5c0 2.5-2.2 4.7-4.8 4.7" }), /* @__PURE__ */ React.createElement("path", { d: "M89.1 66.5h-79c-.4 0-.8-.3-.8-.8V20.3c0-2.1 1.7-3.8 3.8-3.8h73c2.1 0 3.8 1.7 3.8 3.8v45.5c0 .4-.4.7-.8.7z", style: {
  fill: "none",
  stroke: "#000",
  strokeWidth: 3,
  strokeMiterlimit: 10
} }));
export default SvgMac;
